/**
 * Navigation Service
 *
 * Provides a way for non-React code (like HTTP clients) to trigger navigation
 * without creating circular dependencies with the Redux store.
 */

class NavigationService {
  constructor() {
    this.dispatch = null;
  }

  setDispatch(dispatch) {
    this.dispatch = dispatch;
  }

  async triggerAuthFailure() {
    if (this.dispatch) {
      // Import locally to avoid circular dependency at module level
      const { triggerAuthFailureNavigation } = await import(
        '@app/store/appState'
      );
      this.dispatch(triggerAuthFailureNavigation());
    } else {
      // eslint-disable-next-line no-console
      console.error(
        'NavigationService: dispatch not set, falling back to window.location',
      );
      window.location.href = '/auth-failure';
    }
  }
}

// Export singleton instance
export default new NavigationService();
